import React from "react";
import PieChart from "../Common/PieChart";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { GET_DEAL_PERFORMANCE } from "../../query/getDealPerf";
import ActiveDealDot from "../../images/activeDealsDot.svg";
import PastDealDot from "../../images/pastDealDot.svg";
import moment from "moment";
import { VIEW_PROFILE } from "../../query/ViewProfile";

const DealsPerformance = ({ isPrint }) => {
  const { data: userData } = useQuery(VIEW_PROFILE, {
    client: hasuraClient,
  });

  const { data: performanceData } = useQuery(GET_DEAL_PERFORMANCE, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: userData?.users[0]?.business_profile?.id,
      club_profile_id: userData?.users[0]?.club_profile?.id,
      current_date_time: moment().format(),
    },
  });

  const chartData = [
    {
      id: "Active deals",
      label: "Active deals",
      value: performanceData?.active_deals?.aggregate?.count,
    },
    {
      id: "Past deals",
      label: "Past deals",
      value: performanceData?.past_deals?.aggregate?.count,
    },
  ];

  return (
    <div
      className="dealsperformance"
      style={
        isPrint
          ? {
              background: "white",
              padding: "30px",
            }
          : { height: "340px" }
      }
    >
      <div className="title">
        <h2
          style={
            isPrint
              ? { fontSize: "20px", fontWeight: "600", fontFamily: "Inter" }
              : {}
          }
        >
          Deals Performance
        </h2>
      </div>

      <div
        className="dealperformance-chart"
        style={isPrint ? { marginTop: "10%" } : {}}
      >
        <div
          className="dealperformance-box"
          style={
            isPrint
              ? { position: "relative", height: "250px", width: "420px" }
              : {}
          }
        >
          <PieChart data={chartData} />
          <div
            className="dealsperformance-data"
            style={
              isPrint
                ? {
                    position: "absolute",
                    left: "0px",
                    right: "0px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    margin: "0 auto",
                    width: "100%",
                    textAlign: "center",
                    lineHeight: "20px",
                  }
                : {}
            }
          >
            <p
              style={
                isPrint
                  ? {
                      fontSize: "36px",
                      color: "#3F434A",
                      fontWeight: "600",
                    }
                  : {}
              }
            >
              {performanceData?.active_deals?.aggregate?.count +
                performanceData?.past_deals?.aggregate?.count}
            </p>
            <label style={isPrint ? { color: "#8A9099" } : {}}>
              Total Engagement
            </label>
          </div>
        </div>
        <div
          className="pi-footer-row"
          style={
            isPrint
              ? {
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "35px",
                }
              : {}
          }
        >
          <div className="pi-footer-col">
            <span>
              <img src={ActiveDealDot} />{" "}
            </span>
            <span
              className="deal-name"
              style={
                isPrint
                  ? {
                      marginLeft: "9px",
                      color: "#8A9099",
                      fontSize: "14px",
                      lineHeight: "17px",
                    }
                  : {}
              }
            >
              Active deals
            </span>
            <span
              className="count"
              style={isPrint ? { marginLeft: "30px" } : {}}
            >
              {performanceData?.active_deals?.aggregate?.count}
            </span>
          </div>
          <div className="pi-footer-col">
            <span>
              {" "}
              <img src={PastDealDot} />{" "}
            </span>
            <span
              className="deal-name"
              style={
                isPrint
                  ? {
                      marginLeft: "9px",
                      color: "#8A9099",
                      fontSize: "14px",
                      lineHeight: "17px",
                    }
                  : {}
              }
            >
              Past deals
            </span>
            <span
              className="count"
              style={isPrint ? { marginLeft: "30px" } : {}}
            >
              {performanceData?.past_deals?.aggregate?.count}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DealsPerformance;
